  window.thrillSubscribeUrl = '/inc/ajax/subscribe2.asp';

  (function ($) {
    if (!$) {
      return;
    }

    $('.subscribe-form').each(function () {
      var form = $(this),
        renderedAt = form.find('input[name="subscribe_rendered_at"]');

      if (renderedAt.length) {
        renderedAt.attr('data-rendered-at', String(Date.now()));
        renderedAt.val('0');
      }
    });

    $('.subscribe-form').off('submit').on('submit.thrillSubscribe', function (e) {
      var form = $(this),
        message = form.find('.form-message'),
        renderedAt = form.find('input[name="subscribe_rendered_at"]'),
        renderedAtMs = Number(renderedAt.attr('data-rendered-at') || 0),
        payload;

      e.preventDefault();

      if (!window.csrfToken && typeof window.ensureThrillSession === 'function') {
        form.find('.submit').prop('disabled', true);
        window.ensureThrillSession().done(function () {
          form.find('.submit').prop('disabled', false);
          form.trigger('submit');
        }).fail(function () {
          form.find('.submit').prop('disabled', false);
          message.removeClass('text-success').addClass('text-danger').html('Session expired. Please refresh and try again.').fadeIn();
        });
        return;
      }

      if (renderedAt.length && renderedAtMs > 0) {
        renderedAt.val(String(Math.max(0, Date.now() - renderedAtMs)));
      }

      payload = form.serializeArray();

      if (window.csrfToken) {
        payload.push({ name: 'CSRFToken', value: window.csrfToken });
      }

      $.ajax({
        url: window.thrillSubscribeUrl,
        type: 'POST',
        data: $.param(payload),
        dataType: 'json',
        error: function () {
          form.find('.submit').prop('disabled', false);
          message.removeClass('text-success').addClass('text-danger')
            .text('Unable to subscribe right now. Please try again.').show();
        },
        success: function (data) {
          form.find('.submit').prop('disabled', true);

          message.removeClass('text-danger').removeClass('text-success').fadeIn();

          switch (data.status) {
            case '0':
              message.html(data.html).addClass('text-success').fadeIn();

              setTimeout(function () {
                form.trigger('reset');

                message.fadeOut().delay(900).queue(function () {
                  message.html('').dequeue();
                });
              }, 2000);
              break;

            case '1':
            case '2':
              message.html(data.html).addClass('text-danger').fadeIn();

              if (data.status === '2') {
                setTimeout(function () {
                  form.trigger('reset');

                  message.fadeOut().delay(900).queue(function () {
                    message.html('').dequeue();
                  });
                }, 2000);
              }
              break;

            default:
              message.html(data.html || 'Please wait a moment and try again.').addClass('text-danger').fadeIn();
              break;
          }

          form.find('.submit').prop('disabled', false);
        }
      });
    });
  })(window.jQuery);


(function () {
  if (!window.teTrackEvent) {
    window.teTrackEvent = function (eventType, payload) {
      if (!eventType) return;

      var data = payload || {};
      data.eventType = eventType;

      var endpoint = "/inc/api/trackcustomerevent.aspx";
      var body = JSON.stringify(data);
      if (navigator.sendBeacon) {
        try {
          var blob = new Blob([body], { type: "application/json" });
          if (navigator.sendBeacon(endpoint, blob)) return;
        } catch (e) {}
      }

      if (window.fetch) {
        fetch(endpoint, {
          method: "POST",
          credentials: "include",
          keepalive: true,
          cache: "no-store",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: body
        }).catch(function () {});
      }
    };
  }

  if (!window.teTrackClickThruForm) {
    window.teTrackClickThruForm = function (body) {
      if (!body) return;
      if (window.teLastClickThruFormBody === body) return;
      window.teLastClickThruFormBody = body;

      var endpoint = "/inc/api/storeclickthru.aspx";
      if (navigator.sendBeacon) {
        try {
          var blob = new Blob([body], { type: "application/x-www-form-urlencoded;charset=UTF-8" });
          if (navigator.sendBeacon(endpoint, blob)) return;
        } catch (e) {}
      }

      if (window.fetch) {
        fetch(endpoint, {
          method: "POST",
          credentials: "include",
          keepalive: true,
          cache: "no-store",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: body
        }).catch(function () {});
      }
    };
  }
})();

// Read the shared session and managed basket for header counts and CSRF.
// Keep an unavailable count blank rather than presenting a false empty basket.
(function ($) {
  'use strict';
  var counts = $('.desktop-cart-button .count, .mobile-menu-drawer__cart .count');
  counts.text('');
  function refreshContext() {
    var query = new URLSearchParams(window.location.search);
    if (window.tePageTrackingToken) query.set('__page_token', window.tePageTrackingToken);
    query.set('__landing_path', window.location.pathname);
    query.set('__landing_query', window.location.search);
    query.set('__referrer', document.referrer);
    return $.ajax({
      url: '/inc/ajax/retail-page-context.aspx?' + query.toString(),
      dataType: 'json', cache: false
    }).done(function (data) {
      if (Number.isInteger(data.cartItemCount) && data.cartItemCount >= 0) {
        counts.text(data.cartItemCount).css('visibility', 'visible');
      }
      if (data.csrfToken) window.csrfToken = data.csrfToken;
      if (data.clickThruFormBody) window.teTrackClickThruForm(data.clickThruFormBody);
    });
  }
  if (!window.browseSessionDeferred) refreshContext();
  window.addEventListener('thrill-session-ready', refreshContext);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted && !window.browseSessionDeferred) refreshContext();
  });
})(window.jQuery);
